import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {Container, ContentDescriptions, TextBold, Text, IconWrapper} from "./styled";
import React from "react";
import {CompanyExtensionEntity} from "@dropDesk/domain/entities/plan_extensions/company_extension.entity";
import {formatCurrency} from "@dropDesk/utils/helpers/common";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";


const CurrentExtensions = (
    {
        installedExtensions
    }: {
        installedExtensions: CompanyExtensionEntity[]
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <Container>
            <TextBold size={17} color={colors.text}>Extensões Ativas:</TextBold>

            {installedExtensions.map((ext) => (
                <ContentDescriptions key={ext.idExtension}>
                    <IconWrapper>
                        <DropDeskIcon icon={ICONS_DROPDESK.extension} size={15} color={colors.hintInverse}/>
                        <Text color={colors.text} size={15}>{ext.extensionCatalog?.name ?? 'Extensão'}</Text>
                    </IconWrapper>
                    <Text color={colors.text} size={15}>{formatCurrency(ext.unitPrice)}</Text>
                </ContentDescriptions>
            ))}
        </Container>
    );
}
export default CurrentExtensions;
